import React from 'react'
import { Skeleton, Shade } from '.'

type ArticleCardMiniSkeletonProps = {
  className?: string
  shade?: Shade
}

export const ArticleCardMiniSkeleton = ({ className, shade }: ArticleCardMiniSkeletonProps) => {
  return (
    <div className={`c-article-card-mini ${className}`}>
      <Skeleton shade={shade} className="c-article-card-mini__image" />
      <Skeleton shade={shade} className="c-article-card-mini__title u-h-16" />
      <Skeleton shade={shade} className="c-article-card-mini__title u-h-16" />
    </div>
  )
}
